<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('menu.reason') }}
        </h3>
        <div class="box-tools pull-right">
          <template v-if="can([$Permissions.backend.setting.reason.store])">
            <button
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              data-target="#createReason"
            >
              <i class="fa fa-plus-circle" /> {{ $t('button.add') }}
            </button>
          </template>
        </div>
      </div>
      <div class="box-body">
        <table
          id="loan-officer-assign"
          class="table table-hover table-striped table-bordered"
        >
          <tbody />
        </table>
      </div>
    </div>
    <CreateReasonModal
      :products="products"
      @refreshList="oTable.draw()"
    />
    <EditReasonModal
      :products="products"
      @refreshList="oTable.draw()"
    />
  </div>
</template>

<script>
import CreateReasonModal from './modals/CreateReasonModal'
import EditReasonModal from './modals/EditReasonModal'

export default {
  name: 'List',
  components: {
    EditReasonModal,
    CreateReasonModal
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  computed: {
    pageTitle () {
      return this.$t('menu.reason')
    },
    products () {
      return [
        { id: 1, name: this.$t('product.payday'), value: 'payday' },
        { id: 2, name: this.$t('product.personal'), value: 'personal' },
        { id: 3, name: this.$t('product.purchasing'), value: 'purchasing' },
        { id: 4, name: this.$t('product.pawn'), value: 'pawn' }
      ]
    }
  },
  watch: {
    '$i18n.locale' () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
    }
  },
  methods: {
    onDelete (id) {
      this.onConfirm().then((accept) => {
        if (accept) {
          this.$isLoading(true)
          this.$axios.post(this.$base_api + '/api/v4/backend/reason/delete', {
            reason_id: id
          }).then(() => {
            this.onDeleted()
            this.oTable.draw()
          }).catch((error) => {
            this.onResponseError(error)
          }).finally(() => {
            this.$isLoading(false)
          })
        }
      })
    },
    refreshTable () {
      return $('#loan-officer-assign').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v4/backend/reason/datatable',
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '2%',
            title: this.$t('table.action'),
            render: (data, type, row) => {
              let action = ''
              if (this.can([this.$Permissions.backend.setting.reason.edit])) {
                action += `<button class="btn btn-primary btn-edit btn-xs" title="${this.$t('label.edit')}" data-toggle="modal" data-target="#editReason" data-id="${row.id}"><i class="fa fa-edit"></i> </button> `
              }
              if (this.can([this.$Permissions.backend.setting.reason.delete])) {
                action += `<button class="btn btn-danger btn-delete btn-xs" title="${this.$t('label.delete')}" data-id="${row.id}"><i class="fa fa-trash"></i> </button>`
              }

              return action
            }
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          {
            data: 'reason',
            name: 'reason',
            width: '8%',
            title: this.$t('table.reason'),
            render: (data, type, row) => `${row.number} - ${data}` || this.$t('string.na')
          },
          {
            data: 'for_cancellation',
            name: 'for_cancellation',
            width: '8%',
            title: this.$t('table.for_cancellation'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          },
          {
            data: 'for_rejection',
            name: 'for_rejection',
            width: '8%',
            title: this.$t('table.for_rejection'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          },
          {
            data: 'for_payday',
            name: 'for_payday',
            width: '8%',
            title: this.$t('table.for_payday'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          },
          {
            data: 'for_personal',
            name: 'for_personal',
            width: '8%',
            title: this.$t('table.for_personal'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          },
          {
            data: 'for_installment',
            name: 'for_installment',
            width: '8%',
            title: this.$t('table.for_installment'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          },
          {
            data: 'for_pawn',
            name: 'for_pawn',
            width: '8%',
            title: this.$t('table.for_pawn'),
            render: (data) => {
              if (data) {
                return '<span class="label label-info"><i class="fa fa-check"></i></span>'
              }
              return '<span class="label label-danger"><i class="fa fa-times"></i> </span>'
            }
          }
        ],
        order: [[1, 'desc']],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    enabledAction () {
      this.clearEventHandlers([
        '.btn-delete',
        '.btn-edit'
      ])
      const self = this
      $(document).on('click', '.btn-delete', function () {
        self.onDelete($(this).attr('data-id'))
      })

      $(document).on('click', '.btn-edit', function () {
        const id = $(this).attr('data-id')
        self.$store.commit('reason/toggleEditModal')
        self.$store.commit('reason/setReasonId', id)
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.enabledAction()
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
